var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 19.964,
    viewBox: "0 0 21.5 19.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.086,23.964,12.75,23.2l3.071-5.375h4.607a1.536,1.536,0,0,0,1.536-1.536V7.071a1.536,1.536,0,0,0-1.536-1.536H5.071A1.536,1.536,0,0,0,3.536,7.071v9.214a1.536,1.536,0,0,0,1.536,1.536h6.911v1.536H5.071A3.071,3.071,0,0,1,2,16.286V7.071A3.071,3.071,0,0,1,5.071,4H20.429A3.071,3.071,0,0,1,23.5,7.071v9.214a3.071,3.071,0,0,1-3.071,3.071H16.712Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,10H20.286v1.536H8Zm0,4.607h7.679v1.536H8Z",
    transform: "translate(-1.393 -1.393)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.0516e4076b7e2eb9f61d4060d2d923a2.svg";
export { ForwardRef as ReactComponent };